import { isNullOrUndefined } from 'utils/Global';

//Significant digits and Precision Values taken from V3
export const significantDigitsConcentration = 5;
export const precisionConcentration = 3;
export const significantDigitsVolume = 5;
export const precisionVolume = 3;
export const significantDigitsPH = 2;
export const precisionPH = 2;

const getZeros = (zeroCount: number): string => {
  if (zeroCount < 0) {
    zeroCount = Math.abs(zeroCount);
  }
  return '0'.repeat(zeroCount);
};
export const applyPrecision = (
  value: number,
  significantDigits: number,
  precision: number,
): string => {
  if (isNullOrUndefined(value)) {
    return '';
  }
  const numString = value.toString();
  let numberOfDecimalDigits;
  const integerPart: string = numString.split('.')[0];

  if (integerPart.length >= significantDigits) {
    return integerPart;
  }

  if (integerPart === '0') {
    numberOfDecimalDigits = significantDigits;
  } else {
    numberOfDecimalDigits = significantDigits - integerPart.length;
  }

  if (numberOfDecimalDigits > precision) {
    if (value >= parseFloat(`0.${getZeros(precision - 1)}1`)) {
      numberOfDecimalDigits = precision;
    }
  }
  return value.toFixed(numberOfDecimalDigits);
};
